import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Image, ArrowLeft, FileText, X } from "react-feather";
import { Modal, Button, Form } from "react-bootstrap";
import { toast } from "react-toastify";
import testImg from "../../assets/images/samples/test.jpg";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

function PenugasanDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [previewImg, setPreviewImg] = useState(null);
  const [show, setShow] = useState(false);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [manualMembers, setManualMembers] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState(""); // "ambil" | "reject"
  const [showReasonModal, setShowReasonModal] = useState(false);
  const [reason, setReason] = useState("");

  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const dd = String(today.getDate()).padStart(2, "0");
  const dateStr = `${yyyy}${mm}${dd}`;
  // Dummy: ambil data order by id
  const dummyOrders = [
    {
      id: 1,
      external_ref: `TGR-${dateStr}-001`,
      customer_name: "Budi",
      customer_phone: "08123456789",
      customer_address: "Jl. Melati No. 12",
      is_customer: true,
      channel: "Call Center",
      complaint_type: "Air Mati",
      job_type: "Perbaikan",
      category: "Teknis",
      description: "Air tidak keluar sejak pagi",
      region_id: "Region-01",
      province: "Jawa Barat",
      kabupaten: "Bandung",
      kecamatan: "Cimahi",
      kelurahan: "Leuwigajah",
      photo_url: testImg,
      created_by: "Admin",
      tanggal: "2025-09-24 16:55:40",
      priority: "critical",
      kasie: "Monkey D Luffy",
      status: "new",
    },
    {
      id: 2,
      external_ref: `TGR-${dateStr}-002`,
      customer_name: "Siti",
      customer_phone: "08987654321",
      customer_address: "Jl. Mawar No. 45",
      is_customer: false,
      channel: "Mobile App",
      complaint_type: "Meter Rusak",
      job_type: "Penggantian",
      category: "Meteran",
      description: "Meter tidak bisa terbaca",
      region_id: "Region-02",
      province: "Jawa Tengah",
      kabupaten: "Semarang",
      kecamatan: "Tembalang",
      kelurahan: "Meteseh",
      photo_url: testImg,
      created_by: "Operator",
      tanggal: "2025-09-23 11:55:40",
      priority: "critical",
      kasie: "Monkey D Luffy",
      status: "in_progress",
    },
    {
      id: 3,
      external_ref: `TGR-${dateStr}-003`,
      customer_name: "Andi",
      customer_phone: "08122334455",
      customer_address: "Jl. Kenanga No. 8",
      is_customer: true,
      channel: "Website",
      complaint_type: "Air Keruh",
      job_type: "Inspeksi",
      category: "Kualitas",
      description: "Air berwarna coklat sejak kemarin",
      region_id: "Region-03",
      province: "DKI Jakarta",
      kabupaten: "Jakarta Selatan",
      kecamatan: "Tebet",
      kelurahan: "Manggarai",
      photo_url: testImg,
      created_by: "Customer Service",
      tanggal: "2025-09-22 10:20:40",
      priority: "critical",
      kasie: "Monkey D Luffy",
      status: "new",
    },
  ];

  // Toggle member
  const handleToggleMember = (id) => {
    setSelectedMembers((prev) =>
      prev.includes(id) ? prev.filter((m) => m !== id) : [...prev, id]
    );
  };

  const handleRemoveManual = (id) => {
    setManualMembers((prev) => prev.filter((m) => m.id !== id));
  };

  // === HANDLE PREVIEW ===
  const handlePreview = (img) => {
    setPreviewImg(img);
    setShow(true); // buka modal
  };

  const handleClose = () => {
    setShow(false); // tutup modal
    setPreviewImg(null);
  };

  const handleOpenModal = (type) => {
    setModalType(type);
    setShowModal(true);
  };

  const handleConfirm = () => {
    if (modalType === "ambil") {
      console.log("Ambil tiket:", order.id);
      // TODO: panggil API ambil tiket
    } else if (modalType === "reject") {
      // Tutup modal konfirmasi
      setShowModal(false);
      // Buka modal alasan reject
      setShowReasonModal(true);
    }
    setShowModal(false);
  };

  const handleSubmitReason = () => {
    if (!reason.trim()) {
      toast.error("Harap berikan alasan penolakan sebelum melanjutkan.");
      return;
    }

    console.log("Alasan reject:", reason);

    setShowReasonModal(false);
    toast.success("Tiket berhasil ditolak dengan alasan: " + reason);
    setReason("");
  };

  const order = dummyOrders.find((o) => String(o.id) === id);

  if (!order) {
    return (
      <div className="container mt-4">
        <h4>Data tidak ditemukan</h4>
        <button className="btn btn-secondary mt-3" onClick={() => navigate(-1)}>
          Kembali
        </button>
      </div>
    );
  }

  return (
    <>
      <div className="container mt-4">
        <div className="card shadow-sm">
          {/* Header utama */}
          <div className="card-header" style={{ backgroundColor: "#1a237e" }}>
            <h5 className="mb-0 text-white">
              Detail Tiket {order.external_ref}
            </h5>
          </div>

          <div className="card-body">
            {/* Header Info Tiket */}
            {/* <div className="mt-3">
              <div
                className="py-3 px-3 text-white"
                style={{
                  backgroundColor: "#3949ab",
                  borderTopLeftRadius: "0.5rem",
                  borderTopRightRadius: "0.5rem",
                }}
              >
                <h6 className="mb-0 text-white">Info Tiket</h6>
              </div>
            </div> */}

            <div
              className="d-flex justify-content-end px-3 py-2"
              style={{ backgroundColor: "#f5f6fa" }}
            ></div>

            {/* Tabel detail */}
            <div className="table-responsive">
              <table className="table table-bordered align-middle">
                <tbody>
                  <tr>
                    <th style={{ width: "20%" }}>Nama Pelanggan</th>
                    <td style={{ width: "30%" }}>{order.customer_name}</td>
                    <th style={{ width: "20%" }}>Telepon</th>
                    <td style={{ width: "30%" }}>{order.customer_phone}</td>
                  </tr>
                  <tr>
                    <th>Alamat</th>
                    <td>{order.customer_address}</td>
                    <th>Status Pelanggan</th>
                    <td>{order.is_customer ? "Pelanggan" : "Non Pelanggan"}</td>
                  </tr>
                  <tr>
                    <th>Media</th>
                    <td>{order.channel}</td>
                    <th>Category</th>
                    <td>{order.category}</td>
                  </tr>
                  <tr>
                    <th>Wilayah</th>
                    <td>{order.region_id}</td>
                    <th>Provinsi</th>
                    <td>{order.province}</td>
                  </tr>
                  <tr>
                    <th>Kabupaten</th>
                    <td>{order.kabupaten}</td>
                    <th>Kecamatan</th>
                    <td>{order.kecamatan}</td>
                  </tr>
                  <tr>
                    <th>Kelurahan</th>
                    <td>{order.kelurahan}</td>
                    <th>Priority</th>
                    <td>
                      <span
                        className={`badge ${
                          order.priority === "critical"
                            ? "bg-danger"
                            : order.priority === "medium"
                            ? "bg-warning text-dark"
                            : "bg-success"
                        }`}
                      >
                        {order.priority}
                      </span>
                    </td>
                  </tr>
                  <tr>
                    <th>Keluhan</th>
                    <td>{order.description}</td>
                    <th>Bukti Foto</th>
                    <td>
                      {order.photo_url ? (
                        <button
                          className="btn btn-sm btn-primary d-flex align-items-center"
                          onClick={() => handlePreview(order.photo_url)}
                        >
                          <Image size={16} className="me-1" />
                          Lihat Gambar
                        </button>
                      ) : (
                        <span className="text-muted">Tidak ada bukti foto</span>
                      )}
                    </td>
                  </tr>
                  {[4].includes(
                    JSON.parse(localStorage.getItem("user"))?.role_id
                  ) && (
                    <tr>
                      <th>Kasie</th>
                      <td>{order.kasie}</td>
                      <th>Aksi</th>
                      <td className="d-flex gap-2">
                        <button
                          className="btn btn-sm text-white d-flex align-items-center"
                          style={{ backgroundColor: "rgb(29, 145, 37)" }}
                          onClick={() => handleOpenModal("ambil")}
                        >
                          <FileText size={16} className="me-1" />
                          Ambil Tiket
                        </button>

                        <button
                          className="btn btn-sm text-white d-flex align-items-center"
                          style={{ backgroundColor: "rgb(200, 50, 50)" }}
                          onClick={() => handleOpenModal("reject")}
                        >
                          <X size={16} className="me-1" />
                          Reject
                        </button>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Action buttons */}
            {/* Footer Aksi */}
            <div className="d-flex justify-content-between mt-3">
              {/* Kiri */}
              <div>
                <button
                  className="btn btn-secondary d-flex align-items-center"
                  onClick={() =>
                    navigate("/Wo/Penugasan", {
                      state: { defaultTab: "new" },
                    })
                  }
                >
                  <ArrowLeft size={16} className="me-1" />
                  Kembali
                </button>
              </div>

              {/* Kanan */}
              <div>
                {/* <button className="btn btn-success d-flex align-items-center">
                  <Download size={16} className="me-1" />
                  Ambil Tiket
                </button> */}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Preview */}
      <Modal show={show} onHide={handleClose} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Preview Foto</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          {previewImg ? (
            <img
              src={previewImg}
              alt="Preview"
              className="img-fluid rounded shadow"
            />
          ) : (
            <p className="text-muted">Tidak ada gambar</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Tutup
          </Button>
        </Modal.Footer>
      </Modal>
      {/* Modal Konfirmasi */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>
            {modalType === "ambil"
              ? "Konfirmasi Ambil Tiket"
              : "Konfirmasi Reject Tiket"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalType === "ambil"
            ? "Apakah Anda yakin ingin mengambil tiket ini?"
            : "Apakah Anda yakin ingin menolak (reject) tiket ini?"}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Batal
          </Button>
          <Button
            variant={modalType === "ambil" ? "success" : "danger"}
            onClick={handleConfirm}
          >
            {modalType === "ambil" ? "Ambil Tiket" : "Reject Tiket"}
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={showReasonModal} onHide={() => {}} centered>
        <Modal.Header>
          <Modal.Title>Alasan Reject Tiket</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Tulis alasan penolakan</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Masukkan alasan..."
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary">Batal</Button>
          <Button variant="danger" onClick={handleSubmitReason}>
            Simpan Alasan
          </Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default PenugasanDetail;
